import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Drawer, Stack } from "@mui/material";
import IconButton from "@mui/material/IconButton";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useMenu } from "@shared/hooks/SectionHook";
import React, { useEffect, useMemo, useState } from "react";
import { useLocation } from "react-router-dom";
import NavigationItem from "./NavigationItem";
import generateTemplatePropsFromContents from "@frontoffice/utils/templates/generateTemplatePropsFromContents";
import { useSites } from "@shared/hooks/SiteHook";
import { useHomePageLocation } from "@administration/hooks/PageHook";
import LinkEditor from "@administration/components/editor/LinkEditor";
import Link from "@shared/components/contents/link/Link";
import useGlobalStore from "@shared/store/GlobalStore";
const Navigation = () => {
    const location = useLocation();
    const [menuMobileActive, setMenuMobileActive] = useState(false);
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("md"));
    const { currentSite: site } = useSites();
    const { settings: siteSettings } = site || {};
    const { logoHeader = null } = siteSettings || {};
    const { isBo } = useGlobalStore((state) => ({ isBo: state.isBo }));
    const { homePage } = useHomePageLocation();
    const { menu } = useMenu(site?.id);
    useEffect(() => {
        if (!isMobile && menuMobileActive)
            setMenuMobileActive(false);
    }, [isMobile, menuMobileActive, location]);
    const menuItems = useMemo(() => {
        const menuContents = (menu &&
            generateTemplatePropsFromContents(menu.contents)) || { menus: [] };
        if (menuContents?.menus && !Array.isArray(menuContents?.menus)) {
            return [menuContents?.menus];
        }
        return menuContents?.menus || [];
    }, [menu]);
    if (isMobile) {
        return (_jsxs(_Fragment, { children: [_jsx("nav", { children: _jsx(IconButton, { "aria-label": "Bouton d'ouverture du menu mobile", size: "medium", onClick: () => setMenuMobileActive(true), sx: { color: "primary.contrastText" }, children: _jsx("i", { className: "fal fa-bars" }) }) }), _jsxs(Drawer, { open: menuMobileActive, onClose: () => setMenuMobileActive(false), anchor: "right", slotProps: {
                        paper: {
                            sx: {
                                backgroundColor: "background.paper",
                                minWidth: "300px",
                                maxWidth: "100%",
                            },
                        },
                    }, children: [_jsxs(Stack, { direction: "row", component: "nav", sx: {
                                width: "100%",
                                alignItems: "center",
                                justifyContent: "space-between",
                                px: 2,
                                py: 1,
                            }, children: [isBo ? (_jsx(LinkEditor, { page: homePage, onClick: () => setMenuMobileActive(false), children: logoHeader || (_jsx("img", { alt: "", src: "/logo-docaposte-agility-blue.svg", width: 200 })) })) : (_jsx(Link, { url: "/", onClick: () => setMenuMobileActive(false), children: logoHeader || (_jsx("img", { alt: "", src: "/logo-docaposte-agility-blue.svg", width: 200 })) })), _jsx(IconButton, { "aria-label": "Bouton de fermeture du menu mobile", onClick: () => setMenuMobileActive(false), size: "medium", sx: { color: "text.primary", my: 2, width: 40, height: 40 }, children: _jsx("i", { className: "fal fa-times" }) })] }), _jsx(Stack, { component: "nav", spacing: 4, onClick: (event) => {
                                const target = event.target;
                                if (target?.closest("a")) {
                                    setMenuMobileActive(false);
                                }
                            }, sx: {
                                alignItems: "flex-start",
                                mt: 3,
                                px: 2,
                                "& a, & .MuiTypography-root, & i": {
                                    color: (theme) => `${theme.palette.text.primary} !important`,
                                },
                            }, children: menuItems?.map((menuItem) => (_jsx(NavigationItem, { menuItem: menuItem, depth: 0 }, menuItem?.id))) })] })] }));
    }
    return (_jsx(Stack, { component: "nav", "aria-label": "Navigation principale", direction: "row", spacing: 4, sx: { alignItems: "center" }, children: menuItems?.map((menuItem) => (_jsx(NavigationItem, { menuItem: menuItem, depth: 0 }, menuItem?.id))) }));
};
export default Navigation;
